/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { fetchGraphQl } from '../fetch-graphql';
import { UPDATE_CUSTOMER_V2 } from './graphql/updateCustomer.graphql';
import { handleNetworkError } from '@/account/lib/network-error';
import { handleFetchError } from '@/account/lib/fetch-error';
import { convertKeysCase } from '@/account/lib/convertCase';

export const updateCustomer = async (
  form: Record<string, string>
): Promise<string> => {
  return await fetchGraphQl(UPDATE_CUSTOMER_V2, {
    method: 'POST',
    variables: {
      input: convertKeysCase(form, 'snakeCase', {
        firstName: 'firstname',
        lastName: 'lastname',
        middleName: 'middlename',
        dob: 'date_of_birth',
        custom_attributesV2: 'custom_attributes',
      }),
    },
  })
    .then((response) => {
      if (response.errors?.length) return handleFetchError(response.errors);

      return response?.data?.updateCustomerV2?.customer?.email || '';
    })
    .catch(handleNetworkError);
};
